import React, { useState, useEffect } from "react";
import { Redirect, useHistory } from "react-router-dom";
import "./FormularioExamen.css";
import ReferenciaOnline from "../utilities/ReferenciaOnline";
import generarLineaCaptura from "../utilities/GenerarLineaCaptura";
import { plantelDeMatricula } from "../utilities/plantel";

const FormularioExamen = ({
  conceptos = [], 
  alumno = { codigo: "0000000000" },
  precio = 0,
  cambiarPagar = () => {},
  tablaConceptos,
  cambiarPrecio = () => {},
  cambiarDatosPago = () => {},
  cambiarTablaConceptos = () => {},
}) => {
  const history = useHistory();
  const [checked, cambiarChecked] = useState({ examenes: "0", cursos: "0" });
  const [error, cambiarError] = useState(false);

  const dataExamen = conceptos.find(c => c.clave === "15") || { precio: 120, concepto: "Examen Extraordinario", clave: "15" };
  const dataCurso = conceptos.find(c => c.clave === "27") || { precio: 150, concepto: "Curso Intersemestral", clave: "27" };

  const HandleOnChange = (e) => {
    cambiarChecked({ ...checked, [e.target.name]: e.target.value });
    cambiarError(false);
  };

  useEffect(() => {
    cambiarPrecio(0);
    cambiarTablaConceptos([]);
  }, [cambiarPrecio, cambiarTablaConceptos]);

  useEffect(() => {
    let total = dataExamen.precio * parseInt(checked.examenes) + dataCurso.precio * parseInt(checked.cursos);
    cambiarPrecio(total);
  }, [checked, dataExamen.precio, dataCurso.precio, cambiarPrecio]);

  const CrearPago = async () => {
    if (precio === 0) {
      cambiarError(true);
      return;
    }
    let tabla = [];
    
    // Armamos la tabla dependiendo de cuántos seleccione
    if (checked.examenes > 0) {
      for (let i = 0; i < checked.examenes; i++) {
        tabla.push({
          concepto: dataExamen.concepto,
          clave: dataExamen.clave,
          precio: dataExamen.precio.toString(),
        });
      }
    }
    
    if (checked.cursos > 0) {
      for (let i = 0; i < checked.cursos; i++) {
        tabla.push({
          concepto: dataCurso.concepto,
          clave: dataCurso.clave,
          precio: dataCurso.precio.toString(),
        });
      }
    }

    cambiarTablaConceptos(tabla);
    cambiarError(false);

    let importe = precio.toString().concat(".00");
    const matriculaStr = String(alumno.codigo);
    
    // Calculamos el plantel con las reglas exactas para la línea de captura
    const plantelOficialAlumno = plantelDeMatricula(matriculaStr);

    // Extraemos solo las claves en un arreglo (ej. ["15", "15", "27"])
    const arregloClaves = tabla.map(item => item.clave);
    
    // Generamos la REFERENCIA M97 (El Centro de Mando)
    const datosReferencia = generarLineaCaptura(plantelOficialAlumno, arregloClaves, matriculaStr, precio);
    
    // CORRECCIÓN: Agregamos .banorte
    const refaux = datosReferencia.banorte.lineaDeCaptura;

    // Obtenemos la llave encriptada para el banco
    let base64 = await ReferenciaOnline(refaux, importe);

    // NOTA: El fetch() hacia la base de datos fue eliminado.
    // La pantalla de FormaPago.js se encargará de registrarlo al dar clic en generar.

    // MEJORA: Mandamos también la de Bancomer para el PDF
    cambiarDatosPago({
      referencia: refaux,
      referenciaBBVA: datosReferencia.bancomer.lineaDeCaptura,
      importe: importe,
      key: base64,
      detallesCompletos: datosReferencia
    });
    
    cambiarPagar(true);
    history.push("/formadepago");
  };

  return alumno.codigo === "" ? (
    <Redirect to="/login" />
  ) : (
    <div className="FormularioExamen-container container">
      <button 
        className="FormularioExamen-btn-regresar" 
        onClick={() => history.push("/tipo")}
      >
        &#8592; Regresar
      </button>

      <h2>Exámenes Extraordinarios y Cursos Intersemestrales</h2>
      
      <div className="FormularioExamen-card">
        <h3>Costos Unitarios <span>Información</span></h3>
        <p>A continuación se muestran los precios para cada concepto:</p>
        
        <ul className="FormularioExamen-list">
          <li>
            <div className="FormularioExamen-list-item-content">
              <span>{dataExamen.concepto}</span>
              <span className="FormularioExamen-list-price">${Number(dataExamen.precio).toFixed(2)} c/u</span>
            </div>
          </li>
          <li>
            <div className="FormularioExamen-list-item-content">
              <span>{dataCurso.concepto}</span>
              <span className="FormularioExamen-list-price">${Number(dataCurso.precio).toFixed(2)} c/u</span>
            </div>
          </li>
        </ul>
        
        <div className="FormularioExamen-card-footer">
          <p>
            Selecciona la cantidad que necesitas de cada uno en la parte inferior para calcular tu total automáticamente.
          </p>
        </div>
      </div>

      <div className="FormularioExamen-flex">
        <div className="FormularioExamen-form">
          <div className="FormularioExamen-section">
            <p>¿Cuántos {dataExamen.concepto}s?</p>
            <div className="FormularioExamen-radios">
              {[0, 1, 2, 3].map((num) => (
                <label key={`exam-${num}`}>
                  <input
                    type="radio"
                    name="examenes"
                    value={num.toString()}
                    checked={checked.examenes === num.toString()}
                    onChange={HandleOnChange}
                  />
                  {num === 0 ? "Ninguno" : num}
                </label>
              ))}
            </div>
          </div>

          <div className="FormularioExamen-section">
            <p>¿Cuántos {dataCurso.concepto}s?</p>
            <div className="FormularioExamen-radios">
              {[0, 1, 2].map((num) => (
                <label key={`curso-${num}`}>
                  <input
                    type="radio"
                    name="cursos"
                    value={num.toString()}
                    checked={checked.cursos === num.toString()}
                    onChange={HandleOnChange}
                  />
                  {num === 0 ? "Ninguno" : num}
                </label>
              ))}
            </div>
          </div>
        </div>

        <div className="FormularioExamen-paybox">
          <div className="FormularioExamen-total">
            <h4>
              Total:
              <span>${Number(precio).toFixed(2)}</span>
            </h4>
          </div>
          {error ? (
            <div className="Formulario-error">
              <p>⚠️ Selecciona al menos un concepto para continuar.</p>
            </div>
          ) : null}
          <input
            className="Formulario-boton"
            type="button"
            onClick={CrearPago}
            value="CONTINUAR"
          />
        </div>
      </div>
    </div>
  );
};
export default FormularioExamen;